import { render, staticRenderFns } from "./ArticulatingScreen.vue?vue&type=template&id=e1a44222&"
import script from "./ArticulatingScreen.vue?vue&type=script&lang=js&"
export * from "./ArticulatingScreen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports